import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/services/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../shared/services/user.service';
import { StorageService } from '../../shared/services/storage.service';
import { User } from '../../shared/interfaces/user.interface';

@Component( {
  selector: 'ngx-app-prealert',
  templateUrl: './prealert.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [ './prealert.component.scss' ],
} )
export class PrealertComponent implements OnInit {
  pageForm: FormGroup;
  loginForm: FormGroup;
  submitted: boolean;
  closeResult = '';
  user: User = {};

  private item = {
    amount: null, // Campo que se envia por defecto
    description: '', // Campo del formulario
    weight: 0, // Campo del formulario
    use_measure: true, // Campo que se envia por defecto
    width: 0, // Campo que se envia por defecto
    height: 0, // Campo que se envia por defecto
    depth: 0, // Campo que se envia por defecto
  };
  private items = [];

  constructor(
    private toastr: ToastrService,
    private modalService: NgbModal,
    private storage: StorageService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
  ) {
    this.createForm();
  }

  get f() {
    return this.pageForm.controls;
  }

  get l() {
    return this.loginForm.controls;
  }

  ngOnInit(): void {
    if ( this.storage.getItem( 'inbox-user' ) ) {
      this.user = this.storage.getItem( 'inbox-user' );
    }
  }

  open( content ): void {
    this.submitted = true;
    if ( this.storage.getItem( 'inbox-user' ) ) {
      if ( this.pageForm.valid ) {
        this.onSubmit();
      }
    } else {
      if ( this.pageForm.valid ) {
        this.openModal( content );
      }
    }
  }

  openModal( content ): void {
    this.modalService.open(
      content,
      {
        ariaLabelledBy: 'modal-basic-title',
        backdropClass: 'modal-custom-backdrop',
      } ).result.then( ( result ) => {
        this.login();
      }, () => {
        //  Close modal on CrossClick
      } );
  }

  onSubmit(): void {
    const data: any = {};
    this.items = [];
    this.item.weight = this.pageForm.value.weight;
    this.item.description = this.pageForm.value.description;
    this.items.push( this.item );

    data.id_status_package = 6;
    data.track_number = this.pageForm.value.track_number;
    data.users_inbox_id = this.user.id || this.pageForm.value.users_inbox_id;
    data.items = this.items;

    this.commonService.prealert( data ).subscribe( response => {
      if ( response?.package ) {
        this.toastr.info( `Prealerta realizada para el tracking ${data.track_number}` );
      }
    } );
  }

  private login(): void {
    this.submitted = true;
    if ( this.loginForm.valid ) {
      this.userService.login( this.loginForm.value ).subscribe( response => {
        this.storage.setLoginData( response );
        this.user = response.user;
        this.pageForm.value.users_inbox_id = this.user.id;
        this.onSubmit();
      } );
    }
  }

  private createForm(): void {
    this.loginForm = this.formBuilder.group( {
      email: [ '', [ Validators.email, Validators.required ] ],
      password: [ '', [ Validators.required ] ],
    } );

    this.pageForm = this.formBuilder.group( {
      track_number: [ '', [ Validators.required ] ],
      description: [ '', [ Validators.required ] ],
      weight: [ '', [ Validators.required ] ],
      users_inbox_id: [ '' ],
    } );
  }

}
